export function ArchitectureStrip() {
  return (
    <section className="bg-navy text-white/90 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-5">
        <div className="font-data text-xs sm:text-sm tracking-wide overflow-x-auto whitespace-nowrap">
          Equinix data centers <span className="text-mint mx-2">·</span>
          sovereign U.S. <span className="text-mint mx-2">·</span>
          VCF 5 + VCD and VCF 9 architectures <span className="text-mint mx-2">·</span>
          vSAN ESA all-NVMe <span className="text-mint mx-2">·</span>
          NSX overlay <span className="text-mint mx-2">·</span>
          Dell PowerEdge <span className="text-mint mx-2">·</span>
          Intel Xeon 6
        </div>
      </div>
    </section>
  )
}
